module.exports = __webpack_public_path__ + "img/pic_02_sel.ec112f9d.png";